import React from 'react';
import { App } from '@mb/App';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { Provider } from 'react-redux';

import { ThemeContainer } from 'ui-widgets';

import BrandsPage from '../BrandsPage/BrandsPage';
import store from '../BrandsPage/redux/store';

const BrandsPageContainer: React.FC = () => {
  return (
    <App>
      <ThemeContainer>
        <IntlProvider>
          <Provider store={store}>
            <BrandsPage />
          </Provider>
        </IntlProvider>
      </ThemeContainer>
    </App>
  );
};

export default BrandsPageContainer;
